import {
  Component,
  OnInit
} from '@angular/core';

import {
  Router
} from '@angular/router';

import {UserService} from '../../services/user.service';
import {NotificationService} from '../../services/notification.service';
import {TranslateService} from '@ngx-translate/core';

import {NestasLangComponent} from '../lang/lang.component';
import {NestasToolbarComponent} from '../toolbar/toolbar.component';


import * as _ from 'lodash';

@Component({
  selector: 'forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit{
  resetEmail = '';
  success = null;

  constructor(private _user: UserService, private _notification: NotificationService, public translate: TranslateService,
    private _router: Router){

  }

  ngOnInit(){

  }

  resetPassword(){
    this._user.sendResetPasswordMail(this.resetEmail).subscribe(
      res => {
        this.success = true;
      },
      err => { this._notification.errorServer(err); }
    );
  }

  cancel(){
    this._router.navigate(['login'], {queryParams: { loggedOut: 'true' }});
  }
}
